import React from "react";
import { Col, Row } from "react-bootstrap";

export const DetailsSkeleton = () => {
  return (
    <div className="details-skeleton d-flex w-100">
      <style>{`
        @keyframes pulse {
          0% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
          100% {
            opacity: 1;
          }
        }
        .details-skeleton .bg-light,
        .details-skeleton [class*="bg-light"] {
          background-color: #e9ecef !important;
          animation: pulse 1.5s ease-in-out infinite;
        }
        .details-skeleton .rounded-circle {
          background-color: #e9ecef !important;
          animation: pulse 1.5s ease-in-out infinite;
        }
      `}</style>
      <div className="w-100" style={{ padding: "10px" }}>
        <div className="h-100 pt-4" style={{ borderRadius: "15px", background: "#f9f9f9" }}>
          <Row className="ms-0 w-100 h-100 pe-2">
            {/* Left Column Skeleton */}
            <Col md={8} className="ps-4" style={{ height: "96%", paddingRight: 1, overflow: "auto" }}>
              {/* Header Section Skeleton */}
              <div className="me-2 " style={{ background: "#fff", paddingTop: "12px", borderRadius: "5px", border: "1px solid #e0e4f8", marginBottom: "10px" }}>
                <div className="d-flex gap-3 align-items-center ms-3 mb-0 pb-0" style={{ paddingBottom: "11px", position: "sticky", background: "#fff", top: "0px" }}>
                  <div style={{ width: "10%" }}>
                    <div className="rounded-circle overflow-hidden border border-3 d-flex justify-content-center align-items-center bg-light" style={{ width: "81px", height: "81px", backgroundColor: "#e0e0e0", borderColor: "#e0e0e0" }}></div>
                  </div>
                  <div style={{ color: "#576f91", fontSize: "13px", fontWeight: 500, width: "85%" }} className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="mb-1 bg-light" style={{ width: "200px", height: "24px", borderRadius: "4px" }}></div>
                      <div className="mb-0 bg-light" style={{ width: "150px", height: "18px", borderRadius: "4px" }}></div>
                    </div>
                    <div className="d-flex align-items-center gap-1" style={{ marginTop: "-2.5rem" }}>
                      {[...Array(4)].map((_, i) => (
                        <div key={i} className="bg-light" style={{ width: "34px", height: "34px", borderRadius: "2px" }}></div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="pt-0 ps-0 pb-0" style={{ background: "transparent", marginTop: "0rem", marginLeft: "6.2rem" }}>
                  <Row className="w-100 ms-0 mb-2">
                    {[...Array(3)].map((_, i) => (
                      <Col md={6} className="mb-3 d-flex align-items-center" key={i}>
                        <div className="bg-light" style={{ width: "15px", height: "15px", borderRadius: "50%", marginRight: "10px" }}></div>
                        <div>
                          <div className="mb-1 bg-light" style={{ width: "50px", height: "12px", borderRadius: "4px" }}></div>
                          <div className="mb-0 bg-light" style={{ width: "150px", height: "14px", borderRadius: "4px" }}></div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>

              {/* Tabs Section Skeleton */}
              <Row className="w-100 ms-0 ps-0 pe-2 mb-2" style={{ minHeight: "250px" }}>
                <Col md={12} className="bg-white ps-0 pe-0" style={{ border: "1px solid #E0E4F8", borderRadius: "4px" }}>
                  <div className="d-flex" style={{ borderBottom: "1px solid #E0E4F8" }}>
                    {[...Array(5)].map((_, i) => (
                      <div key={i} className="p-3 bg-light" style={{ minWidth: "17%", height: "50px", marginRight: "1px" }}></div>
                    ))}
                  </div>
                  <div className="p-3">
                    <Row className="w-100 ms-0 mb-4 mt-3">
                      {[...Array(6)].map((_, i) => (
                        <Col md={4} className="mb-4 d-flex align-items-start" key={i}>
                          <div className="bg-light" style={{ width: "15px", height: "15px", borderRadius: "50%", marginRight: "10px", marginTop: "6px" }}></div>
                          <div>
                            <div className="mb-1 bg-light" style={{ width: "80px", height: "12px", borderRadius: "4px" }}></div>
                            <div className="mb-0 bg-light" style={{ width: "120px", height: "14px", borderRadius: "4px" }}></div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Col>
              </Row>

              {/* Second Tabs Section Skeleton */}
              <Row className="w-100 ms-0 mt-2 ps-0 pe-2" style={{ minHeight: "390px" }}>
                <Col md={12} className="bg-white ps-0 pe-0" style={{ border: "1px solid #E0E4F8", borderRadius: "4px" }}>
                  <div className="d-flex" style={{ borderBottom: "1px solid #E0E4F8" }}>
                    {[...Array(3)].map((_, i) => (
                      <div key={i} className="p-3 bg-light" style={{ minWidth: "17%", height: "70px", marginRight: "1px" }}></div>
                    ))}
                  </div>
                  <div className="p-3" style={{ height: "320px" }}></div>
                </Col>
              </Row>
            </Col>

            {/* Right Column Skeleton */}
            <Col md={4} style={{ height: "96%", borderLeft: "1px solid #d1d4e3" }} className="pt-0">
              <div className="card h-100" style={{ border: "1px solid #E0E4F8" }}>
                <div className="card-header d-flex justify-content-between align-items-center py-3" style={{ borderBottom: "1px solid #E0E4F8" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "3px", justifyContent: "space-between", width: "100%" }}>
                    <div className="d-flex align-items-center gap-1">
                      {[...Array(4)].map((_, i) => (
                        <div key={i} className="bg-light" style={{ height: "34px", width: "80px", borderRadius: "2px" }}></div>
                      ))}
                    </div>
                    <div className="d-flex align-items-center gap-1">
                      <div style={{ borderRight: "1px solid #E0E4F8", height: "35px", margin: "0px 2px" }}></div>
                      <div className="bg-light" style={{ width: "34px", height: "34px", borderRadius: "2px" }}></div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="bg-light" style={{ width: "80px", height: "24px", borderRadius: "4px" }}></div>
                    <div className="d-flex align-items-center gap-1">
                      <div className="bg-light" style={{ width: "34px", height: "34px", borderRadius: "4px" }}></div>
                      <div className="bg-light" style={{ width: "80px", height: "34px", borderRadius: "4px" }}></div>
                    </div>
                  </div>
                  <div className="mt-3 bg-light" style={{ height: "200px", borderRadius: "4px" }}></div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};